import { c as _c } from "react/compiler-runtime";
import type { BigIntish } from '@morpho-org/blue-sdk';
import { isDefined } from '@morpho-org/morpho-ts';
import { memo, useMemo } from 'react';
import { formatPreciseDuration } from '@/components/VaultPage/helpers/timelock';
import { getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultPendingTimelock.components';
import VaultPendingTimelockHeader from './VaultPendingTimelockHeader';
interface VaultPendingTimelockChangeTimelockProps {
  timelock: BigIntish;
  currentTimelock?: BigIntish;
  functionName: string;
}
const VaultPendingTimelockChangeTimelock = t0 => {
  const $ = _c(19);
  const {
    timelock,
    currentTimelock,
    functionName
  } = t0;
  let t1;
  if ($[0] !== currentTimelock || $[1] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName,
      hasPreviousValue: isDefined(currentTimelock)
    });
    $[0] = currentTimelock;
    $[1] = functionName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const config = t1;
  let t2;
  if ($[3] !== currentTimelock) {
    t2 = isDefined(currentTimelock) ? formatPreciseDuration(currentTimelock) : null;
    $[3] = currentTimelock;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const currantTimelockDuration = t2;
  let t3;
  if ($[5] !== timelock) {
    t3 = formatPreciseDuration(timelock);
    $[5] = timelock;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const timelockDuration = t3;
  let t4;
  if ($[7] !== config) {
    t4 = config && <VaultPendingTimelockHeader title={config.label} criticality={config.criticality} />;
    $[7] = config;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== currantTimelockDuration || $[10] !== currentTimelock) {
    t5 = isDefined(currentTimelock) && <StyledVaultPendingTimelock.Row><span className="text-2xs text-foreground">Initial value</span><span className="text-2xs text-foreground">{currantTimelockDuration}</span></StyledVaultPendingTimelock.Row>;
    $[9] = currantTimelockDuration;
    $[10] = currentTimelock;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-2xs text-foreground">New value</span>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== timelockDuration) {
    t7 = <StyledVaultPendingTimelock.Row>{t6}<span className="text-2xs text-foreground">{timelockDuration}</span></StyledVaultPendingTimelock.Row>;
    $[13] = timelockDuration;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t7) {
    t8 = <div className="flex w-[100%] flex-col">{t4}{t5}{t7}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default memo(VaultPendingTimelockChangeTimelock);